<template>
  <section>
    <div
      class="question vh-min-100 center-cover"
      :class="{'d-none' : active != question_key}"
      v-for="(question, question_key) in questions"
      :key="question_key"
      :style="{'background-image':
        `url(${question.background
        ||'/images/bangerhead_1.jpg'})`}"
    >
    <div class="question-wrapper d-flex align-items-center justify-content-center pt-0 pt-sm-5">
      <div class="QuestionForm primary-block">
        <div
          v-for="(question, question_key) in questions"
          :key="question_key"
          :class="{'d-none' : active != question_key}"
        >
          <h1 class="mb-3 mb-md-4">{{question.question}}</h1>
          <p class="mb-4">{{question.description}}</p>
          <hr class="mb-4">
          <ul class="QuestionFormList">
            <li v-for="(answer, answer_key) in question.options" :key="answer_key">
              <label :for="answer.id.toString()">
                <div class="d-flex flex-column flex-grow pr-4">
                  <span class="answer">{{answer.value}}</span>
                  <small>{{answer.description}}</small>
                </div>
                <span class="progress-mark" v-bind:class="{ active: answer.selected }"></span>
              </label>
              <b-form-checkbox
                :id="answer.id.toString()"
                v-model="answer.selected"
                :name="answer.id.toString()"
                :value="answer.value"
                v-on:change="check_selected"
              >
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
    <div
      class="controller d-flex align-items-center justify-content-between flex-column flex-md-row"
    >
      <button
        v-if="active > 0"
        v-on:click="prev_question"
        class="btn btn-secondary d-none d-md-block"
      >
        {{ texts.previous }}
      </button>
      <div class="progress-bar d-none d-md-flex">
        <span class="progress-mark" v-for="(progress, progress_key) in questions"
        :key="progress_key" :class="{'active' : active >= progress_key}"></span>
      </div>
      <span class="progress-count d-block d-md-none mb-3">
        {{ texts.question }} {{active + 1}}/{{questions.length}}
      </span>
      <button
        v-on:click="next_question"
        class="btn btn-secondary mb-md-0 mb-3 btn-md-sm ml-0 ml-md-auto"
      >
        {{ active + 1 == questions.length ? texts.send : texts.fillAnswers }}
      </button>
      <button
        v-if="active > 0"
        v-on:click="prev_question"
        class="btn btn-link d-block d-md-none"
      >
        {{ texts.goBack }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  question: 'QuestionForm',
  data() {
    return {
      active: 0,
      is_last: false,
      questions: [],
      isSending: false,
      texts: {},
    };
  },
  mounted() {
    // const { token } = this.$route.query;
    // if(token) {
    //   console.log(token)
    //   this.$cookies.set('token',token);
    // }

    this.get_data();
  },
  methods: {
    async next_question() {
      const el = await this.questions[this.active];
      if (!el.selected) {
        alert('Please answer all questions'); // eslint-disable-line no-alert
      }

      if (el.selected) this.active += 1;

      if (this.active === this.questions.length && el.selected) {
        this.sendAnswers();
      }

      window.scrollTo(0, 0);
    },
    prev_question() {
      this.active += -1;
    },
    get_data() {
      const { lang } = this.$route.query;
      this.$http
        .get(`/api/question_form/${this.$route.params.id}/?lang=${lang || 'sv'}`)
        .then(response => response.data)
        .then((response) => {
          this.questions = response.form.questions;
          this.texts = response.texts;
        });
    },
    async check_selected() {
      /**
       * Add ned selection to fields
       */
      const el = await this.questions[this.active];
      if (!el.selected) el.selected = [];
      await el.options.map(async (element) => {
        if (element.selected && !el.selected.includes(element.id)) {
          await el.selected.push(element.id);
        }
        return true;
      });
      const newObject = this.questions;

      /**
       * If currently active is more then it is allowed to, remove the earliest added answer
       */
      if (el.selected.length > el.max_answers) {
        const newArray = el.selected.slice(1);
        el.selected = newArray;
        await el.options.map(async (element, index) => {
          if (!el.selected.includes(element.id)) {
            el.options[index].selected = false;
          }
        });
      }
      /**
       * Set the new object and update questions
       */
      newObject[this.active] = el;
      this.questions = newObject;
      this.$forceUpdate();
    },
    async sendAnswers() {
      const { token, l, lang } = this.$route.query;
      const loggedin = l === 'True';
      this.isSending = true;
      const answers = [];

      await this.questions.map(async (element) => {
        answers.push({
          value: element.selected,
          id: element.id,
        });
      });

      this.$http.post('/api/question_form/register/', {
        form_id: this.$route.params.id,
        answers,
        token,
        l: loggedin,
        lang,
      })
        .then((r) => {
          this.isSending = false;
          if (r.data.loggedin) {
            this.$router.push({ path: `/result/hero/${r.data.id}?lang=${lang || 'sv'}` });
          } else {
            this.$router.push({ path: `/login?id=${r.data.id}&lang=${lang || 'sv'}` });
          }
        });
    },
  },
};
</script>
